import { useNavigate } from "react-router-dom";

import { Icon } from "atoms/icon/Icon";
import CheckSmall from "atoms/icon/icons/ic_check_small_ol.svg";
import OfferIcon from "atoms/icon/icons/ic_offers_ol.svg";
import OpenRewardIcon from "atoms/icon/icons/open_reward.svg";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

interface ItemAppliedToCartModalProps {
  onClose: () => void;
  itemName?: string | null;
  itemType: "reward" | "offer";
}

export const ItemAppliedToCartModal = ({
  onClose,
  itemName,
  itemType,
}: ItemAppliedToCartModalProps) => {
  const navigate = useNavigate();

  const itemTypeTitleCase =
    itemType.charAt(0).toUpperCase() + itemType.slice(1).toLowerCase();

  const icon = itemType === "reward" ? OpenRewardIcon : OfferIcon;

  return (
    <ActionModal
      size="small"
      open={true}
      headerIconSvg={icon}
      onClose={onClose}
      onFirstButtonClick={() => navigate("/cart")}
      firstButtonLabel="Continue to cart"
      onSecondButtonClick={() => navigate("/shop")}
      secondButtonLabel="Explore shop"
      title={`${itemTypeTitleCase} applied to cart!`}
      useAnimatedBackground={true}
      description={!!itemName && <ItemAppliedToCart name={itemName} />}
    />
  );
};

const ItemAppliedToCart = ({ name }: { name: string }) => {
  return (
    <div className="mb-5 flex rounded p-3">
      <div className="flex w-full items-center gap-3">
        <Icon svg={CheckSmall} color="successGreen" size="small" />
        <div className="flex w-full flex-col items-start gap-1 text-left">
          <div className="text-bold2 text-primary">{name}</div>
          <div className="text-body2 text-secondary">
            has been applied to your cart.
          </div>
        </div>
      </div>
    </div>
  );
};
